import FloatingLabel from '../utils/_floating-label'

export default function FloatingLabels () {
    GravityFormsLabels()
}

function GravityFormsLabels () {
    // Init when Gravity Forms renders
    jQuery(document).on('gform_post_render', function(event, formId) {
        const formElementId = `#gform_${formId.toString()}`
        const gravityFormFields = new FloatingLabel(`${formElementId} .gfield`)
    })
}